import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SideMenu.scss";
import { getCounts } from "../../api/apiServiceFetch";
import useAdminRealtimeTick from "../../hooks/useAdminRealtimeTick";

const SideMenu = ({ isMenuOpen, setIsMenuOpen }) => {
	const navigate = useNavigate();
	const realtimeTick = useAdminRealtimeTick();

	const [counts, setCounts] = useState({
		allUsers: 0,
		newUsers: 0,
		editsUsers: 0,
		failedUsers: 0,
		blockedUsers: 0,
		delUsers: 0,
		allReports: 0,
		newReports: 0,
	});

	const fetchCounts = async () => {
		try {
			const countsData = await getCounts();
			setCounts(countsData);
		} catch (error) {
			console.error("Error fetching counts:", error);
		}
	};

	useEffect(() => {
		fetchCounts();
	}, [realtimeTick]);

	const handleNavigation = (path) => {
		navigate(path);
		fetchCounts();
		setIsMenuOpen(false);
	};

	return (
		<>
			<div
				className={`side-menu-backdrop ${isMenuOpen ? "visible" : ""}`}
				onClick={() => setIsMenuOpen(false)}
			/>

			<div className={`side-menu ${isMenuOpen ? "open" : ""}`}>
				<div className="side-menu__title">Разделы</div>

				<ul>
					<li onClick={() => handleNavigation("/")}>Дашборд</li>

					<li onClick={() => handleNavigation("/all-profiles")}>
						Все профили <span>{counts.allUsers}</span>
					</li>

					<li onClick={() => handleNavigation("/new-profiles")}>
						Новые профили
						<span>{counts.newUsers > 0 ? `${counts.newUsers}` : ""}</span>
					</li>

					<li onClick={() => handleNavigation("/edit-profiles")}>
						Изменённые профили
						<span>{counts.editsUsers > 0 ? `${counts.editsUsers}` : ""}</span>
					</li>

					<li onClick={() => handleNavigation("/fail-profiles")}>
						Фейл профили <span>{counts.failedUsers}</span>
					</li>

					<li onClick={() => handleNavigation("/blocked-profiles")}>
						Заблокированные <span>{counts.blockedUsers}</span>
					</li>

					<li onClick={() => handleNavigation("/deleted-profiles")}>
						Удалённые <span>{counts.delUsers}</span>
					</li>

					<li onClick={() => handleNavigation("/reports")}>
						Жалобы
						<span>{counts.allReports > 0 ? `${counts.allReports}` : ""}</span>
						{counts.newReports > 0 ? (
							<span className="side-menu__badge">{counts.newReports}</span>
						) : null}
					</li>

					<li onClick={() => handleNavigation("/orders")}>
						Покупки и Инвестиции
					</li>
					<li onClick={() => handleNavigation("/order-discounts")}>
						Тарифы и скидки
					</li>
					<li onClick={() => handleNavigation("/broadcasts")}>Рассылки</li>
					<li onClick={() => handleNavigation("/config")}>Конфигурация</li>
					<li onClick={() => handleNavigation("/users")}>Администраторы</li>
				</ul>
			</div>
		</>
	);
};

export default SideMenu;
